export default __webpack_public_path__ + "static/media/icon-notifications.257bacd6.svg";